'use client';

import { CatButton } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { BUNDLE_BEAN, PACKAGE_BEAN } from '../../constants/constants';
import { FC, useMemo, useState } from 'react';
import styles from './customize-kit-button.module.scss';
import KitDrawerWrapper from '../kit-drawer/kit-drawer-section';
import { CurrentItemsWithPrice } from 'services/fbtItems/types';
import { DealerPriceAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import { DealerResponse } from 'services/dealer';
import { LocationResponse } from 'services/location/types';
import { CartResponse, OrderItemsResponseKit } from 'services/cart/types';
import { isCustomizedKitProduct } from '../../utils/isCustomizedKitProduct';
import { useProductDetailPageContext } from '../../context/product-detail';

interface CustomizeKitProps {
  data?: CurrentItemsWithPrice;
  userFlags?: { isLoggedIn: boolean; isInstantAccessUser: boolean };
  priceAvailabilityDrawerData?: DealerPriceAvailabilityResponse;
  dealerInformation?: DealerResponse;
  getEsites;
  availRemoveInterimStockFlag?: boolean;
  isShowSourcingDetailEnabled?: boolean;
  isDeliveryEnabled?: boolean;
  userStoreLocationData?: LocationResponse;
  isHeadlessPDPEnabled?: boolean;
  orderItems?: Array<OrderItemsResponseKit>;
  contactDealerComp?: React.ReactNode;
  isGuestUser?: boolean;
  catcorp?: boolean;
  cartDetails?: CartResponse;
  priceAvailabilityData;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
  isCustomizeKitQuantityEnabled?: boolean;
  isHeadlessPriceAndAvailability: boolean;
}
const CustomizeKitButton: FC<CustomizeKitProps> = ({
  data,
  userFlags,
  priceAvailabilityDrawerData,
  dealerInformation,
  getEsites,
  availRemoveInterimStockFlag,
  isShowSourcingDetailEnabled,
  isDeliveryEnabled,
  userStoreLocationData,
  isHeadlessPDPEnabled,
  orderItems,
  contactDealerComp,
  isGuestUser,
  catcorp,
  cartDetails,
  priceAvailabilityData,
  isRTL = false,
  currencyLdFeatureFlag = false,
  isCustomizeKitQuantityEnabled,
  isHeadlessPriceAndAvailability
}) => {
  const productType = data?.type;
  const isPackage = productType === PACKAGE_BEAN;
  const isBundle = productType === BUNDLE_BEAN;
  const productComponents = data?.components;
  const isCustomizable = data?.isCustomizable;
  const t = useTranslations();
  const { isInstantAccessUser, isLoggedIn } = userFlags;
  const [kitDrawerActive, setKitDrawerActive] = useState(false);
  const { quantity: updatedQuantity } = useProductDetailPageContext();

  const updatedData = useMemo(() => {
    if (isCustomizeKitQuantityEnabled) {
      return {
        ...data,
        components: data?.components?.map((item) => ({
          ...item,
          quantity: Number(item.quantity) * Number(updatedQuantity)
        }))
      };
    }
    return data;
  }, [data, updatedQuantity, isCustomizeKitQuantityEnabled]);

  return (
    isCustomizedKitProduct(
      productComponents,
      isInstantAccessUser,
      isLoggedIn,
      isPackage,
      isCustomizable,
      isBundle,
      isGuestUser,
      catcorp
    ) && (
      <>
        <CatButton
          onClick={() => setKitDrawerActive(true)}
          className={`${styles['customize-kit-button']}`}
          variant="contrast"
        >
          {t('KITS_CUSTOMIZE_KIT')}
        </CatButton>
        {kitDrawerActive && (
          <KitDrawerWrapper
            kitDrawerActive={kitDrawerActive}
            setKitDrawerActive={setKitDrawerActive}
            data={updatedData}
            priceAvailabilityDrawerData={priceAvailabilityDrawerData}
            dealerInformation={dealerInformation}
            getEsites={getEsites}
            availRemoveInterimStockFlag={availRemoveInterimStockFlag}
            isShowSourcingDetailEnabled={isShowSourcingDetailEnabled}
            isDeliveryEnabled={isDeliveryEnabled}
            isHeadlessPDPEnabled={isHeadlessPDPEnabled}
            userStoreLocationData={userStoreLocationData}
            orderItems={orderItems}
            contactDealerComp={contactDealerComp}
            cartDetails={cartDetails}
            priceAvailabilityData={priceAvailabilityData}
            isRTL={isRTL}
            currencyLdFeatureFlag={currencyLdFeatureFlag}
            isHeadlessPriceAndAvailability={isHeadlessPriceAndAvailability}
          />
        )}
      </>
    )
  );
};
export default CustomizeKitButton;
